import React, { useEffect } from "react";
import { useLanguage } from "../lib/language";
import { translations } from "../lib/translations";

export function TermsOfUsePage() {
  const { language } = useLanguage();
  const t = translations;

  useEffect(() => {
    // Scroll to top immediately
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    // Also ensure scroll to top after a small delay in case content is still loading
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            {t.termsOfUseTitle[language]}
          </h1>

          <p className="text-sm text-gray-600 mb-8">
            {t.termsOfUseLastUpdated[language]}
          </p>

          <div className="space-y-8">
            <div>
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.termsOfUseIntro[language]}
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.termsOfUseSection1Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.termsOfUseSection1Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.termsOfUseSection2Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.termsOfUseSection2Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.termsOfUseSection3Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.termsOfUseSection3Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.termsOfUseSection4Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.termsOfUseSection4Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.termsOfUseSection5Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.termsOfUseSection5Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.termsOfUseSection6Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.termsOfUseSection6Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.termsOfUseSection7Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.termsOfUseSection7Content[language]}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
